/* =====================================================================
   Everblooming — site interactions (dependency-free vanilla JS)
   - sticky nav state + mobile menu
   - reveal-on-scroll (IntersectionObserver)
   - HERO CAROUSEL: single banner, 4 auto-switching scenes
       crossfade + Ken-Burns + petal overlay + dots/arrows/progress
       auto-advance, pause on hover, pause when off-screen, keyboard
   - falling-petal canvas over the hero (color switches per slide)
   - count-up stats on scroll
   All motion honors prefers-reduced-motion.
   ===================================================================== */
(function(){
  "use strict";
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- nav ---- */
  var nav = document.querySelector('.nav');
  var links = document.querySelector('.nav .links');
  var burger = document.querySelector('.nav .burger');
  function onScroll(){ if(nav){ nav.classList.toggle('solid', window.scrollY > 40); } }
  window.addEventListener('scroll', onScroll, {passive:true}); onScroll();
  if(burger){ burger.addEventListener('click', function(){ links.classList.toggle('open'); }); }
  if(links){ links.addEventListener('click', function(e){ if(e.target.tagName==='A') links.classList.remove('open'); }); }

  /* ---- reveal on scroll ---- */
  var revEls = document.querySelectorAll('.reveal');
  if('IntersectionObserver' in window && !reduced){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } });
    }, {threshold:0.16});
    revEls.forEach(function(el){ io.observe(el); });
  } else {
    revEls.forEach(function(el){ el.classList.add('in'); });
  }

  /* ---- falling petals (single hero canvas, color-switchable) ---- */
  function PetalField(canvas, colors){
    var ctx = canvas.getContext('2d');
    var w=0,h=0,dpr=Math.min(window.devicePixelRatio||1,2), petals=[], raf=null, running=false;
    var COUNT = 0;
    function resize(){
      w = canvas.clientWidth; h = canvas.clientHeight;
      canvas.width = w*dpr; canvas.height = h*dpr; ctx.setTransform(dpr,0,0,dpr,0,0);
      COUNT = Math.max(12, Math.min(52, Math.round(w/30)));
      build();
    }
    function build(){ petals = []; for(var i=0;i<COUNT;i++) petals.push(spawn(true)); }
    function spawn(anywhere){
      return {
        x: Math.random()*w,
        y: anywhere ? Math.random()*h : -20 - Math.random()*60,
        s: 5 + Math.random()*9,
        vy: 14 + Math.random()*26,
        vx: (Math.random()-0.5)*14,
        rot: Math.random()*Math.PI*2,
        vr: (Math.random()-0.5)*1.4,
        sway: Math.random()*Math.PI*2,
        col: colors[(Math.random()*colors.length)|0],
        op: 0.5 + Math.random()*0.4
      };
    }
    function petalPath(p){
      ctx.save();
      ctx.translate(p.x,p.y); ctx.rotate(p.rot); ctx.globalAlpha = p.op;
      ctx.fillStyle = p.col;
      ctx.beginPath();
      ctx.moveTo(0,-p.s);
      ctx.quadraticCurveTo(p.s*0.9,-p.s*0.2, 0,p.s);
      ctx.quadraticCurveTo(-p.s*0.9,-p.s*0.2, 0,-p.s);
      ctx.fill();
      ctx.restore();
    }
    var last=0;
    function frame(t){
      if(!running) return;
      if(!last) last=t; var dt=Math.min(0.05,(t-last)/1000); last=t;
      ctx.clearRect(0,0,w,h);
      for(var i=0;i<petals.length;i++){
        var p=petals[i];
        p.sway += dt*1.6;
        p.y += p.vy*dt;
        p.x += (p.vx + Math.sin(p.sway)*10)*dt;
        p.rot += p.vr*dt;
        if(p.y > h+24){ petals[i]=spawn(false); }
        petalPath(p);
      }
      raf = requestAnimationFrame(frame);
    }
    return {
      start:function(){ if(running||reduced) return; running=true; last=0; raf=requestAnimationFrame(frame); },
      stop:function(){ running=false; if(raf) cancelAnimationFrame(raf); ctx.clearRect(0,0,w,h); },
      resize:resize,
      setColors:function(c){ if(c && c.length) colors = c; }  // new petals adopt the new palette
    };
  }

  /* ---- HERO CAROUSEL ---- */
  (function(){
    var hero = document.querySelector('.hero');
    if(!hero) return;
    var slides = [].slice.call(hero.querySelectorAll('.slide'));
    if(!slides.length) return;
    var dotsWrap = hero.querySelector('.hero__dots');
    var progress = hero.querySelector('.hero__progress span');
    var prevBtn = hero.querySelector('.hero__arrow--prev');
    var nextBtn = hero.querySelector('.hero__arrow--next');
    var INTERVAL = 6500;
    var cur = 0, timer = null, inView = true;

    // petal overlay
    var canvas = hero.querySelector('.hero__petals');
    var petals = canvas ? PetalField(canvas, (canvas.getAttribute('data-colors')||'#ffffff').split(',')) : null;
    if(petals){ petals.resize(); window.addEventListener('resize', petals.resize); }

    // build dots
    var dots = [];
    slides.forEach(function(s, i){
      var b = document.createElement('button');
      b.setAttribute('role','tab');
      b.setAttribute('aria-label','Go to scene ' + (i+1));
      if(i===0) b.className = 'is-active';
      b.addEventListener('click', function(){ go(i); restartAuto(); });
      dotsWrap && dotsWrap.appendChild(b);
      dots.push(b);
    });

    function applyPetalColors(){
      if(!petals) return;
      var c = slides[cur].getAttribute('data-petals');
      if(c) petals.setColors(c.split(','));
    }

    function runProgress(){
      if(!progress) return;
      progress.style.transition = 'none';
      progress.style.width = '0%';
      // force reflow so the reset takes effect before we animate
      // eslint-disable-next-line no-unused-expressions
      progress.offsetWidth;
      if(reduced || !inView){ return; }
      progress.style.transition = 'width ' + INTERVAL + 'ms linear';
      progress.style.width = '100%';
    }

    function go(n){
      n = (n + slides.length) % slides.length;
      if(n === cur){ return; }
      slides[cur].classList.remove('is-active');
      slides[cur].setAttribute('hidden','');
      dots[cur] && dots[cur].classList.remove('is-active');
      cur = n;
      slides[cur].removeAttribute('hidden');
      // reflow to guarantee Ken-Burns + content animations restart
      void slides[cur].offsetWidth;
      slides[cur].classList.add('is-active');
      dots[cur] && dots[cur].classList.add('is-active');
      applyPetalColors();
      runProgress();
    }
    function next(){ go(cur+1); }
    function prev(){ go(cur-1); }

    function startAuto(){
      if(reduced) return;
      stopAuto();
      runProgress();
      timer = setInterval(next, INTERVAL);
    }
    function stopAuto(){ if(timer){ clearInterval(timer); timer = null; } }
    function restartAuto(){ if(!reduced && inView){ startAuto(); } }

    prevBtn && prevBtn.addEventListener('click', function(){ prev(); restartAuto(); });
    nextBtn && nextBtn.addEventListener('click', function(){ next(); restartAuto(); });

    // pause on hover
    hero.addEventListener('mouseenter', function(){
      stopAuto();
      if(progress && !reduced){
        var cs = getComputedStyle(progress).width;
        progress.style.transition = 'none';
        progress.style.width = cs;
      }
    });
    hero.addEventListener('mouseleave', restartAuto);

    // keyboard (when hero is on screen)
    document.addEventListener('keydown', function(e){
      if(!inView) return;
      if(e.key === 'ArrowRight'){ next(); restartAuto(); }
      else if(e.key === 'ArrowLeft'){ prev(); restartAuto(); }
    });

    // occasion cards jump to a specific slide
    document.querySelectorAll('[data-slide]').forEach(function(el){
      el.addEventListener('click', function(){
        var n = parseInt(el.getAttribute('data-slide'), 10) || 0;
        go(n); restartAuto();
      });
    });

    // pause auto + petals when hero scrolls out of view
    if('IntersectionObserver' in window){
      var vio = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          inView = en.isIntersecting;
          if(inView){ startAuto(); petals && petals.start(); }
          else { stopAuto(); petals && petals.stop(); }
        });
      }, {threshold:0.25});
      vio.observe(hero);
    } else {
      petals && petals.start();
    }

    // init
    applyPetalColors();
    if(reduced){ runProgress(); } else { startAuto(); petals && petals.start(); }
  })();

  /* ---- count-up stats ---- */
  (function(){
    var nums = [].slice.call(document.querySelectorAll('[data-count]'));
    if(!nums.length) return;
    function fmt(v, comma, suffix){
      var s = comma ? Math.round(v).toLocaleString('en-US') : String(Math.round(v));
      return s + (suffix||'');
    }
    function animate(el){
      var target = parseFloat(el.getAttribute('data-count')) || 0;
      var suffix = el.getAttribute('data-suffix') || '';
      var comma = el.getAttribute('data-comma') === '1';
      if(reduced){ el.textContent = fmt(target, comma, suffix); return; }
      var dur = 1400, t0 = null;
      function step(ts){
        if(!t0) t0 = ts;
        var p = Math.min(1, (ts - t0)/dur);
        var eased = 1 - Math.pow(1-p, 3);   // easeOutCubic
        el.textContent = fmt(target*eased, comma, suffix);
        if(p < 1) requestAnimationFrame(step);
        else el.textContent = fmt(target, comma, suffix);
      }
      requestAnimationFrame(step);
    }
    if('IntersectionObserver' in window && !reduced){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){ if(en.isIntersecting){ animate(en.target); io.unobserve(en.target); } });
      }, {threshold:0.5});
      nums.forEach(function(el){ io.observe(el); });
    } else {
      nums.forEach(animate);
    }
  })();

  /* ---- footer year ---- */
  var y = document.getElementById('year'); if(y) y.textContent = new Date().getFullYear();
})();
